import React from "react";
import "./RelatedBlogs.css";
import { BlogList } from "../BlogList/BlogList";

export default function RelatedBlogs({ currentLanguage = "en" }) {
    const isFrench = currentLanguage === "fr";

    // ================= CONTENT DATA (SAME FILE) =================
    const contentEN = {
        title: "RELATED BLOGS",
        subtitle: "Explore more strategic insights and industry analysis",
    };

    const contentFR = {
        title: "BLOGS CONNEXES",
        subtitle: "Découvrez davantage d’analyses sectorielles et d’idées stratégiques",
    };

    const content = isFrench ? contentFR : contentEN;

    return (
        <div className="related-blogs-wrapper">
            <h2 className="related-title">{content.title}</h2>
            <p className="related-subtitle">{content.subtitle}</p>

            <div className="related-blogs-list">
                <BlogList hidePagination={true} limit={4} currentLanguage={currentLanguage} />
            </div>
        </div>
    );
}
